console.log('js/components/customer/login.js -> v0.1.0');

(() => {
	$("#plt-login-modal").on("hidden.bs.modal", function () {
		$(".login-form-wrapper .js-error").text("").removeClass('active');
	});

	$("#plt-login-modal").on("show.bs.modal", function () {
		$(".login-form-wrapper .js-error").text("").removeClass('active');
	});

	// "Back to Login" inside #plt-forgot-password-modal relies on
	// data-toggle/data-dismiss to hand off between modals, same as the
	// "Forgot your password?" link (see forgot-password.js) — close it
	// explicitly here too rather than relying on that alone.
	$('#plt-login-modal').on('show', function() {
		$('#plt-forgot-password-modal').modal('hide');
	});

	if (document.querySelector('.bttn--email') !== null ) {
		const emailLogin = document.querySelector('.bttn--email');
	}

	if (document.querySelector('#forgot-password-link') !== null) {
		const forgotPasswordLink = document.querySelector('#forgot-password-link');
		forgotPasswordLink.addEventListener('click', event => {
			const loginStep2 = document.querySelector('.login-step-2');
			const forgotPasswordPane = document.querySelector('#forgot-password-step');
			loginStep2.classList.add('hide');
			forgotPasswordPane.classList.remove('hide');
		});

	}

	$('#plt-login-form').submit(function(event){
		event.preventDefault();
		if(document.querySelector('#login-form-step') !== null) {
			var submitButton = document.querySelector('.login-step-2 .bttn-submit');
			var errorBlock = document.querySelector('.login-step-2 .js-error');
			var csrfToken = document.querySelector('#csrfToken').value;
			submitButton.classList.add('is-loading');
			submitButton.disabled = true;

		}
		else {
			// set loading state
			var submitButton = document.querySelector('.login-form-wrapper .bttn-submit');
			var errorBlock = document.querySelector('.login-form-wrapper .js-error');
			var csrfToken = document.querySelector('#csrfToken').value;
			submitButton.classList.add('is-loading');
			submitButton.disabled = true;

		}


		var request = {
			"email": document.querySelector('#login-email').value,
			"password": document.querySelector('#login-password').value,
			"pageType": document.querySelector('#login-page-type').value
		};

		const params = {
			credentials: 'same-origin',
			method: 'POST',
			body: JSON.stringify(request),
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'X-CSRF-Token': csrfToken
			}
		}

		errorBlock.classList.remove('active');
		gae('customer','login_email_submit');

		fetch("/account/auth/login", params)
			.then(function(response) {
				return response.json();
			})
			.then(function(response) {

				if (response.status == "ok") {
					gae('customer','login_email_submit_ok');
					if(window.location.href.indexOf('/login') > -1) {
						const redirectUrl = document.referrer;
						window.location.href = redirectUrl;
					}
					else {
						window.location.reload();
					}
				}
				if (response.status == "error") {
					setTimeout(function() {
						submitButton.classList.remove('is-loading');
						submitButton.disabled = false;
						errorBlock.classList.add('active');
						errorBlock.innerHTML = response.error;

						gae('customer','login_email_submit_error');
					}, 1000);
				}
			})
			.catch(function(error) {
				console.error('Error:', error);
			});
	});

	$('#promo-code-login-form').submit(function(event){
		event.preventDefault();
		// set loading state
		const submitButton = document.querySelector('.login-form-wrapper .bttn-submit');
		const errorBlock = document.querySelector('.login-form-wrapper .js-error');

		submitButton.classList.add('is-loading');
		submitButton.disabled = true;

		var request = {
			"email": document.querySelector('#promo-code-login-email').value,
			"password": document.querySelector('#promo-code-login-password').value
		};

		const params = {
			credentials: 'same-origin',
			method: 'POST',
			body: JSON.stringify(request),
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			}
		}

		errorBlock.classList.remove('active');
		gae('customer','login_email_submit');

		fetch("/account/auth/login", params)
			.then(function(response) {
				return response.json();
			})
			.then(function(response) {

				if (response.status == "ok") {
					gae('customer','login_email_submit_ok');
					document.querySelector('#promo-code-login-modal').classList.add('hidden');
					document.querySelector('#promo-code-modal').classList.remove('new');
				}
				if (response.status == "error") {
					setTimeout(function() {
						submitButton.classList.remove('is-loading');
						submitButton.disabled = false;
						errorBlock.classList.add('active');
						errorBlock.innerHTML = response.error;

						gae('customer','login_email_submit_error');
					}, 1000);
				}
			})
			.catch(function(error) {
				console.error('Error:', error);
			});
	});
	if(document.querySelector('#login-email-button') !== null) {
		var loginEmailButton = document.querySelector('#login-email-button');
		var backButton = document.querySelector('#login-back-button');
		backButton.addEventListener('click', event => {
			var container = backButton.closest(".login-step-2");
			container.classList.add("hide");
			var step1 = loginEmailButton.closest(".login-step-1");
			step1.classList.remove("hide");
		});

		loginEmailButton.addEventListener('click', event => {
			var container = loginEmailButton.closest(".login-step-1");
			container.classList.add("hide");
			var step2 = document.querySelector('.login-step-2');
			step2.classList.remove("hide");
		});
	}

	document.addEventListener('input', function (event) {
		if(event.target.id == 'login-email') {
			validation.emailValidation(event.target, '.email-validation');
		}
	});

})();
